
import { defineComponent, ref, onMounted, Ref } from "vue";
import useEmitter from "@/composables/Emmiter";
import FilterBase from "@/layout/header/partials/filters/FilterBase.vue";
import Api from "@/services/Api";

interface Filtro {
  marca: string;
  filtro: string;
  tipo: string;
  ean: string;
}

export default defineComponent({
  name: "FilterFiltros",
  components: { FilterBase },
  setup() {
    const emitter = useEmitter();
    const closeModal = ref(false);
    const marcasDeFiltros: Ref<any> = ref([]);
    const paramsFilter: Ref<Filtro> = ref({ marca: "", filtro: "", tipo: "", ean: "" });

    async function getMarcasProduto(){
      try{
        const { data } = await Api.get("getMarcasProdutoDbInfo", {tipoProduto: 'filtros'});
        if(data.length === 0) {
          marcasDeFiltros.value = [];
        } else {
          marcasDeFiltros.value = data;
        }
      }catch(err){
        console.log(err);
      }
    }

    const tiposDeFiltro: Ref<any> = ref([]);

    async function getTipoProdutoFiltros(){
      try{
        const { data } = await Api.get("getTipoProdutoFiltros");
        if(data.length === 0) {
          tiposDeFiltro.value = [];
        } else {
          tiposDeFiltro.value = data;
        }
      }catch(err){
        console.log(err);
      }
    }

    async function enviarEmit() {
      await emitter.emit("paramsFilter", {
        paramsFilter: paramsFilter.value,
      });
      closeModal.value = !closeModal.value;
    }

    onMounted(() => {
      getMarcasProduto();
      getTipoProdutoFiltros();
    });

    return { marcasDeFiltros, enviarEmit, paramsFilter, closeModal, tiposDeFiltro };
  },
});
